import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AddressesStoreModule } from '@modules/addresses-store';
import { CheckoutStoreModule } from '@modules/checkout-store';
import { ComponentsCommonModule } from '@modules/components-common';
import { FooterComponent } from '@modules/components-common/components/footer/footer.component';
import { coreReducer, ENVIRONMENT, LOGGER } from '@modules/core';
import { CoreModule } from '@modules/core/core.module';
import { CustomerStoreModule } from '@modules/customer-store';
import { ErrorPageModule } from '@modules/error-page';
import { TicketsAndFaresStoreModule } from '@modules/ticket-fares-store';
import { TicketSelectorModule } from '@modules/ticket-selector';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { I18nModule } from '@nx-ng/i18n';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { MsalBootstrapComponents, MsalProviders } from './b2c/b2c-config';
import { BannerComponent } from './components/banner/banner.component';
import { PostLoginPageComponent } from './components/post-login-page/post-login-page.component';
import { TicketTypesComponent } from './components/ticket-types/ticket-types.component';
import { ApplicationInsightsService } from './services/application-insights.service';
import { ErrorHandlerService } from './services/error-handler.service';
import { getBaseUrl } from './util/get-base-url';

@NgModule({
  declarations: [
    AppComponent,
    BannerComponent,
    TicketTypesComponent,
    FooterComponent,
    PostLoginPageComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,

    // GTM
    GoogleTagManagerModule.forRoot({
      id: environment.gtm.id,
    }),
    StoreModule.forRoot(coreReducer, {
      metaReducers: !environment.production ? [] : [],
      runtimeChecks: {
        strictActionImmutability: true,
        strictStateImmutability: true,
      },
    }),
    EffectsModule.forRoot([]),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    // Local
    AppRoutingModule,
    CoreModule,
    I18nModule,
    ComponentsCommonModule,
    TicketSelectorModule,
    CheckoutStoreModule,
    StoreModule,
    AddressesStoreModule,
    TicketsAndFaresStoreModule,
    CustomerStoreModule,
    ErrorPageModule,
  ],
  providers: [
    { provide: 'BASE_URL', useFactory: getBaseUrl },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'GBP' },
    { provide: LOGGER, useClass: ApplicationInsightsService },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    { provide: ENVIRONMENT, useValue: environment },
    ...MsalProviders,
  ],
  bootstrap: [AppComponent, ...MsalBootstrapComponents],
})
export class AppModule {}
